import { isCoordinates, isInteger } from '.'

export const isValidCircle = ({ centerPoint = {}, radius }) => {
  const { latitude, longitude } = centerPoint
  return centerPoint && isCoordinates(latitude) && isCoordinates(longitude) && isInteger(radius)
}
